import {h} from 'preact';
import cx from 'classnames';
import {Address} from '@components/common/Address';

const AddressBookItem = ( {children, className = '', onClick = () => {}, ...addressProps} ) =>
    <div className={cx( 'flex items-center', className )} onClick={onClick}>
        {children}
        <Address {...addressProps} />
    </div>;

export default AddressBookItem;